import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { SWReactIcons } from "@similarweb/icons";

export const Container = styled(FlexRow)`
    width: 584px;
    height: 16px;
`;

export const BarPart = styled.div<{ isFilled: boolean; isCurrent: boolean; isLastPart: boolean }>`
    height: 100%;
    flex: 1;
    background: ${({ isFilled }) => (isFilled ? colorsPalettes.blue[350] : colorsPalettes.blue[50])};
    border-right: ${({ isLastPart, isCurrent }) =>
        !isLastPart && (isCurrent ? `2px solid ${colorsPalettes.blue[500]}` : `2px solid ${colorsPalettes.blue[100]}`)};
    position: relative;
`;

export const Index = styled.div`
    ${setFontVariant("dataTable2", colorsPalettes.carbon[300])};
    position: absolute;
    top: 18px;
    right: -3px;
`;

export const IconsContainer = styled.div<{ isLastIndex: boolean }>`
    position: absolute;
    bottom: 18px;
    right: ${({ isLastIndex }) => (isLastIndex ? "-8px" : "-10px")};
`;

export const PinIcon = styled(SWReactIcons)<{ isFilled: boolean }>`
    height: 25px;
    width: 20px;
    position: relative;

    & svg path {
        ${({ isFilled }) =>
            isFilled &&
            `
                fill: ${colorsPalettes.blue[500]};
            `}
    }
`;

export const GiftIcon = styled(SWReactIcons)<{ isFilled: boolean }>`
    height: 13px;
    width: 13px;

    position: absolute;
    top: 2px;
    right: 3px;

    & svg path {
        ${({ isFilled }) =>
            isFilled &&
            `
                fill: ${colorsPalettes.blue[100]};
            `}
    }
`;
